import { ReactNode } from 'react';
import { InputSearch } from 'ui/inputs';
import { BillingPeriodSelector } from '../BillingPeriodSelector';
import { useSimpleIndexContext } from '../SimpleIndexPage/contexts';

type ProjectUsagePageActionsProps = {
  hasDateSelector?: boolean;
  Filters?: ReactNode;
};

export const ProjectUsagePageActions = ({
  hasDateSelector = true,
  Filters,
}: ProjectUsagePageActionsProps) => {
  const { query, setQuery } = useSimpleIndexContext();
  return (
    <>
      {hasDateSelector && <BillingPeriodSelector />}
      {Filters}
      <InputSearch
        id="table-search-input"
        data-test="table-search-input"
        placeholder="Search projects"
        value={query}
        onChange={setQuery}
        handleClear={() => setQuery('')}
      />
    </>
  );
};
